export default {
  statistics: {
    total_followers: 'Łączna liczba obserwujących',
    emails_sent: 'Wysłane e-maile',
    emails_opened: 'Otwarte e-maile',
    emails_clicked: 'Kliknięte e-maile',
    emails_average_open_rate: 'Współczynnik otwarć e-maili',
    emails_average_click_rate: 'Współczynnik kliknięć e-maili',
    push_notifications_sent: 'Wysłane powiadomienia push',
    push_notifications_clicked: 'Kliknięte powiadomienia push',
  },
};
